import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { encryptAES } from ".";
import styles from "./DrawerIframe.module.scss";
import { TTP_NACNAI_URL } from "../../../config";

const prepareIframeParams = (user, token, lng) => {
  let params = {};
  if (user && token) {
    ((params["userId"] = user.id), (params["token"] = token));
  }
  if (lng) {
    params["lng"] = lng;
  }
  params["app"] = "UA";

  return encryptAES(JSON.stringify(params));
};

const ChatBotIframe = ({ lng }) => {
  const { token, user } = useSelector((state) => state.auth);
  const iParams = prepareIframeParams(user, token, lng);

  return (
    <iframe
      id="drawer_iframe"
      allow="allow-scripts allow-same-origin allow-forms allow-popups clipboard-read clipboard-write allow-popups-to-escape-sandbox allow-top-navigation"
      className={styles.iframe}
      src={`${TTP_NACNAI_URL}` + "?params=" + encodeURIComponent(iParams)}
      title="TAMTAM portal"
      onLoad={() => {
        if (document.getElementById("iframe-loader")) {
          document.getElementById("iframe-loader").style.display = "none";
        }
      }}
    />
  );
};

export default ChatBotIframe;
